import { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { X } from 'lucide-react'
import { Sidebar } from './Sidebar'
import { Topbar } from './Topbar'

const TITLES: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/orders': 'Orders',
  '/products': 'Products',
  '/categories': 'Categories',
  '/inventory': 'Inventory',
  '/hero': 'Hero',
  '/blog': 'Blog',
  '/faq': 'FAQs',
  '/users': 'Users',
  '/affiliates': 'Affiliates',
  '/reviews': 'Reviews',
  '/testimonials': 'Testimonials',
  '/video-testimonials': 'Video Reviews',
  '/contact': 'Contact',
  '/settings': 'Settings',
}

function pageTitle(pathname: string): string {
  const seg = '/' + (pathname.split('/')[1] ?? 'dashboard')
  return TITLES[seg] ?? 'Admin'
}

export function AdminShell() {
  const { pathname } = useLocation()
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Desktop sidebar — always visible lg+ */}
      <div className="hidden lg:flex">
        <Sidebar />
      </div>

      {/* Mobile sidebar — overlay drawer */}
      {sidebarOpen && (
        <>
          <div
            className="fixed inset-0 z-40 bg-ink/30 backdrop-blur-sm lg:hidden"
            onClick={() => setSidebarOpen(false)}
          />
          <div className="fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-pop lg:hidden animate-fade-in">
            <div className="flex justify-end p-2">
              <button
                onClick={() => setSidebarOpen(false)}
                className="size-8 rounded-md text-slatey hover:bg-ivory hover:text-ink inline-flex items-center justify-center"
              >
                <X className="size-4" />
              </button>
            </div>
            <Sidebar onNavigate={() => setSidebarOpen(false)} />
          </div>
        </>
      )}

      <div className="flex-1 flex flex-col overflow-hidden">
        <Topbar
          title={pageTitle(pathname)}
          onMenuClick={() => setSidebarOpen(true)}
        />
        <main className="flex-1 overflow-y-auto bg-ivory p-4 md:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
